<template>
  <div class="lang-selector" ref="selector">
    <!-- Trigger: cerrado muestra bandera + siglas -->
    <div
      class="lang-selector_trigger"
      :class="{ 'lang-selector_trigger--auto': highlighted }"
      v-b-tooltip.top.hover.v-warning.noninteractive="
        highlighted ? autoChangedTooltip : ''
      "
      @click="isOpen = !isOpen"
    >
      <img
        v-if="selected.flag"
        :src="selected.flag"
        :alt="value"
        class="lang-selector_flag"
      />
      <span class="lang-selector_abbr">{{ value.toUpperCase() }}</span>
      <span
        class="lang-selector_arrow"
        :class="{ 'lang-selector_arrow--open': isOpen }"
        >&#9660;</span
      >
      <span v-if="highlighted" class="lang-selector_auto-dot"></span>
    </div>

    <!-- Dropdown: abierto muestra bandera + nombre completo -->
    <div v-if="isOpen" class="lang-selector_dropdown">
      <div
        v-for="lang in languages"
        :key="lang.code"
        class="lang-selector_option"
        :class="{ 'lang-selector_option--active': lang.code == value }"
        @click="onSelect(lang.code)"
      >
        <img
          v-if="lang.flag"
          :src="lang.flag"
          :alt="lang.code"
          class="lang-selector_flag"
        />
        <span>{{ lang.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LanguageSelector",
  props: {
    languages: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: "es",
    },
    // Indica que el idioma actual fue aplicado automáticamente (ej. idioma de
    // la asignatura), y no corresponde a la preferencia manual del usuario.
    highlighted: {
      type: Boolean,
      default: false,
    },
    autoChangedTooltip: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    selected() {
      return this.languages.find((l) => l.code === this.value) || {};
    },
  },
  methods: {
    onSelect(code) {
      this.isOpen = false;
      this.$emit("change", code);
    },
    onClickOutside(event) {
      if (this.$refs.selector && !this.$refs.selector.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener("mousedown", this.onClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.onClickOutside);
  },
};
</script>

<style scoped>
.lang-selector {
  position: relative;
  display: inline-block;
  user-select: none;
}

.lang-selector_trigger {
  display: flex;
  align-items: center;
  gap: 7px;
  height: 30px;
  padding: 0 12px;
  border: 1px solid #e6ecf3;
  border-radius: 999px;
  background: #f4f7fb;
  color: #16263b;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}
.lang-selector_trigger:hover {
  background: #eef4f7;
  border-color: #cfe0ee;
  color: #006ec8;
}

.lang-selector_trigger--auto {
  position: relative;
  border-color: #f5a623;
  background: #fff8ec;
}

.lang-selector_trigger--auto:hover {
  border-color: #f5a623;
  background: #fdedd2;
}

.lang-selector_auto-dot {
  position: absolute;
  top: -3px;
  right: -3px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #f5a623;
  border: 1.5px solid #fff;
}

.lang-selector_flag {
  width: 20px;
  height: auto;
  border-radius: 2px;
  flex-shrink: 0;
}

.lang-selector_abbr {
  font-size: 0.8rem;
  font-weight: 600;
  color: inherit;
  line-height: 1;
}

.lang-selector_arrow {
  font-size: 9px;
  color: inherit;
  opacity: 0.7;
  transition: transform 0.2s ease;
  display: inline-block;
}

.lang-selector_arrow--open {
  transform: rotate(180deg);
}

.lang-selector_dropdown {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  background: #fff;
  border: 1px solid #e6ecf3;
  border-radius: 12px;
  overflow: hidden;
  z-index: 9999;
  min-width: 150px;
  padding: 6px;
  box-shadow: 0 12px 30px rgba(16, 38, 73, 0.16);
}

.lang-selector_option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 9px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #3c4856;
  transition: background 0.16s ease, color 0.16s ease;
}

.lang-selector_option:hover {
  background: #eef4f7;
  color: #006ec8;
}

.lang-selector_option--active {
  background: linear-gradient(
    135deg,
    rgba(0, 110, 200, 0.12) 0%,
    rgba(1, 173, 183, 0.12) 100%
  );
  color: #006ec8;
  font-weight: 700;
}
</style>